<template>
    <div class="ChannelDistribution">
        <Site :link="link"></Site>
    </div>
</template>
<script>
import Site from './components/Site.vue'
export default {
    data() {
        return {
            link:
                'https://byk.cloud.pageseagle.com/779212218108948480/912214248799600640/default'
        }
    },
    components: { Site }
}
</script>
<style lang="less">
.ChannelDistribution{
    .page-tab.float{
        bottom: 2.65rem !important;
    }
}
</style>